/* svd-lp-palsvard-quiz.js – Skapad av Claude Code */
(function () {
  'use strict';

  function init() {

  /* ── State ─────────────────────────────────────────────────────────────── */
  var answers = {};
  var currentStep = 1;
  var quizScore       = 0;
  var quizResultType  = '';   // 'positive' | 'neutral'
  var quizHasSymptom  = false;

  /* ── DOM refs ──────────────────────────────────────────────────────────── */
  var pageEl         = document.getElementById('svd-quiz-page');
  var startSection   = document.getElementById('svd-quiz-start');
  var flowSection    = document.getElementById('svd-quiz-flow');
  var loadingSection = document.getElementById('svd-quiz-loading');
  var resultPositive = document.getElementById('svd-result-positive');
  var resultNeutral  = document.getElementById('svd-result-neutral');
  var startBtn       = document.getElementById('svd-start-btn');
  var progressFill   = document.getElementById('svd-progress-fill');
  var progressLabel  = document.getElementById('svd-progress-label');
  var stickyBar      = document.getElementById('svd-sticky-bar');
  var stickyConfirm  = document.getElementById('svd-sticky-confirm');
  var signupSection  = document.getElementById('svd-quiz-signup');
  var signupForm     = document.getElementById('svd-signup-form');
  var signupError    = document.getElementById('svd-signup-error');
  var signupSuccess  = document.getElementById('svd-signup-success');
  var signupSkip     = document.getElementById('svd-signup-skip');
  var _signupSubmitHandler = null;
  var _signupSkipHandler   = null;

  /* ── Read dynamic settings from DOM ────────────────────────────────────── */
  var totalSteps     = flowSection ? parseInt(flowSection.dataset.totalSteps || '1', 10) : 1;
  var scoreThreshold = pageEl      ? parseInt(pageEl.dataset.scoreThreshold  || '5', 10) : 5;

  /* ── Helpers ───────────────────────────────────────────────────────────── */
  function show(el) {
    if (!el) return;
    el.removeAttribute('hidden');
    el.classList.remove('svd-hidden');
  }
  function hide(el) {
    if (!el) return;
    el.setAttribute('hidden', '');
    el.classList.add('svd-hidden');
  }

  function setProgress(step) {
    var pct = Math.round((step / totalSteps) * 100);
    if (progressFill)  progressFill.style.width = pct + '%';
    if (progressLabel) progressLabel.textContent = 'Fråga ' + step + ' av ' + totalSteps;
  }

  /* ── Sticky bar ─────────────────────────────────────────────────────────── */
  function showStickyBar() {
    if (!stickyBar) return;
    show(stickyBar);
    if (pageEl) pageEl.classList.add('has-sticky-bar');
  }
  function hideStickyBar() {
    if (!stickyBar) return;
    hide(stickyBar);
    if (pageEl) pageEl.classList.remove('has-sticky-bar');
  }

  /* ── Compute score ─────────────────────────────────────────────────────────── */
  function computeScore() {
    quizScore      = 0;
    quizHasSymptom = false;
    for (var s = 1; s <= totalSteps; s++) {
      if (answers[s]) {
        quizScore += answers[s].value;
        if (answers[s].symptom) quizHasSymptom = true;
      }
    }
    quizResultType = (quizHasSymptom || quizScore >= scoreThreshold) ? 'positive' : 'neutral';
  }

  /* ── Start ─────────────────────────────────────────────────────────────── */
  if (startBtn) {
    startBtn.addEventListener('click', function () {
      hide(startSection);
      show(flowSection);
      showStep(1);
    });
  }

  /* ── Show step ─────────────────────────────────────────────────────────── */
  function showStep(stepNum) {
    for (var i = 1; i <= totalSteps; i++) {
      var el = document.getElementById('svd-step-' + i);
      if (el) {
        if (i === stepNum) {
          show(el);
          el.style.animation = 'none';
          el.offsetHeight; /* reflow */
          el.style.animation = '';
        } else {
          hide(el);
        }
      }
    }
    currentStep = stepNum;
    setProgress(stepNum);

    /* Update sticky bar for this step */
    var stepEl = document.getElementById('svd-step-' + stepNum);
    if (stepEl && stepEl.dataset.multiple === 'true') {
      if (stickyConfirm) {
        stickyConfirm.textContent = stepEl.dataset.confirmText || 'Nästa →';
        stickyConfirm.dataset.step = stepNum;
      }
      /* Only show bar if user already has selections (e.g. going back) */
      var anySelected = stepEl.querySelectorAll('.svd-quiz-option.is-selected').length > 0;
      if (anySelected) { showStickyBar(); } else { hideStickyBar(); }
    } else {
      hideStickyBar();
    }
  }

  /* ── Advance from step ──────────────────────────────────────────────────── */
  function advanceFrom(stepNum) {
    hideStickyBar();
    if (stepNum < totalSteps) {
      showStep(stepNum + 1);
    } else if (signupSection && signupSection.dataset.position === 'before_results') {
      hide(flowSection);
      computeScore();
      showSignup(function() { showLoading(renderResults); });
    } else {
      hide(flowSection);
      showLoading(showResults);
    }
  }

  /* ── Sticky bar confirm click ───────────────────────────────────────────── */
  if (stickyBar) {
    stickyBar.addEventListener('click', function (e) {
      var btn = e.target.closest('.svd-quiz-confirm');
      if (!btn) return;
      var stepNum = parseInt(btn.dataset.step, 10);
      var stepEl  = document.getElementById('svd-step-' + stepNum);
      if (!stepEl) return;

      var selected = stepEl.querySelectorAll('.svd-quiz-option.is-selected');
      var totalVal = 0, hasSym = false, labels = [];
      selected.forEach(function (opt) {
        totalVal += parseInt(opt.dataset.value, 10) || 0;
        if (opt.dataset.symptom === 'true') hasSym = true;
        if (opt.dataset.label) labels.push(opt.dataset.label);
      });
      answers[stepNum] = { value: totalVal, label: labels.join(', '), symptom: hasSym };
      advanceFrom(stepNum);
    });
  }

  /* ── Option click ──────────────────────────────────────────────────────── */
  var flowEl = document.getElementById('svd-quiz-flow');
  if (flowEl) {
    flowEl.addEventListener('click', function (e) {
      var btn = e.target.closest('.svd-quiz-option');
      if (!btn) return;

      var stepEl  = btn.closest('.svd-quiz-step');
      if (!stepEl) return;
      var stepNum = parseInt(stepEl.dataset.step, 10);
      var isMulti = stepEl.dataset.multiple === 'true';

      if (isMulti) {
        /* Toggle selection */
        btn.classList.toggle('is-selected');

        /* Show/hide sticky bar based on whether anything is selected */
        var anySelected = stepEl.querySelectorAll('.svd-quiz-option.is-selected').length > 0;
        if (anySelected) {
          if (stickyConfirm) stickyConfirm.dataset.step = stepNum;
          showStickyBar();
        } else {
          hideStickyBar();
        }
      } else {
        /* Single choice: mark and auto-advance */
        stepEl.querySelectorAll('.svd-quiz-option').forEach(function (b) {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');

        answers[stepNum] = {
          value:   parseInt(btn.dataset.value, 10),
          label:   btn.dataset.label || '',
          symptom: btn.dataset.symptom === 'true'
        };

        setTimeout(function () { advanceFrom(stepNum); }, 300);
      }
    });
  }

  /* ── Loading screen ─────────────────────────────────────────────────────── */
  function showLoading(callback) {
    if (!loadingSection || loadingSection.dataset.enabled === 'false') {
      callback();
      return;
    }

    var duration = parseInt(loadingSection.dataset.duration || '3', 10) * 1000;
    var msgs     = [
      loadingSection.dataset.msg1,
      loadingSection.dataset.msg2,
      loadingSection.dataset.msg3
    ].filter(Boolean);

    var msgEl  = document.getElementById('svd-loading-message');
    var pctEl  = document.getElementById('svd-loading-pct');
    var ringEl = document.getElementById('svd-loading-ring');
    var circumference = 2 * Math.PI * 26;

    /* Reset */
    if (ringEl) ringEl.style.strokeDashoffset = circumference;
    if (pctEl)  pctEl.textContent = '0%';
    if (msgEl && msgs[0]) msgEl.textContent = msgs[0];

    show(loadingSection);
    loadingSection.scrollIntoView({ behavior: 'smooth', block: 'start' });

    /* Rotate messages with fade */
    var msgIndex = 0;
    var msgStep  = Math.floor(duration / (msgs.length || 1));
    var msgTimer = setInterval(function () {
      msgIndex = (msgIndex + 1) % msgs.length;
      if (msgEl) {
        msgEl.style.opacity = '0';
        setTimeout(function () {
          if (msgEl) { msgEl.textContent = msgs[msgIndex]; msgEl.style.opacity = '1'; }
        }, 220);
      }
    }, msgStep);

    /* Animate progress ring */
    var start = Date.now();
    var raf;
    function tick() {
      var elapsed = Date.now() - start;
      var pct     = Math.min(100, Math.round((elapsed / duration) * 100));
      if (pctEl)  pctEl.textContent = pct + '%';
      if (ringEl) ringEl.style.strokeDashoffset = circumference * (1 - pct / 100);
      if (elapsed < duration) { raf = requestAnimationFrame(tick); }
    }
    raf = requestAnimationFrame(tick);

    setTimeout(function () {
      clearInterval(msgTimer);
      cancelAnimationFrame(raf);
      hide(loadingSection);
      callback();
    }, duration);
  }

  /* ── Signup screen ──────────────────────────────────────────────────────────── */
  function showSignup(callback) {
    if (!signupSection) { callback(); return; }

    /* Remove any handlers left from a previous run */
    if (_signupSubmitHandler && signupForm) {
      signupForm.removeEventListener('submit', _signupSubmitHandler);
    }
    if (_signupSkipHandler && signupSkip) {
      signupSkip.removeEventListener('click', _signupSkipHandler);
    }

    /* Reset UI to form state */
    if (signupForm)    show(signupForm);
    if (signupError)   hide(signupError);
    if (signupSuccess) hide(signupSuccess);

    show(signupSection);
    signupSection.scrollIntoView({ behavior: 'smooth', block: 'start' });

    function advance() {
      hide(signupSection);
      callback();
    }

    _signupSubmitHandler = function(e) {
      e.preventDefault();
      var emailInput = document.getElementById('svd-signup-email');
      var email = emailInput ? emailInput.value.trim() : '';
      if (!email || email.indexOf('@') < 0) return;

      var btn = signupForm ? signupForm.querySelector('[type="submit"]') : null;
      if (btn) { btn.disabled = true; btn.style.opacity = '0.6'; }

      submitToKlaviyo(email, function(ok) {
        if (btn) { btn.disabled = false; btn.style.opacity = ''; }
        if (ok) {
          if (signupForm)    hide(signupForm);
          if (signupError)   hide(signupError);
          if (signupSuccess) show(signupSuccess);
          setTimeout(advance, 2000);
        } else {
          if (signupError) show(signupError);
        }
      });
    };

    _signupSkipHandler = function() { advance(); };

    if (signupForm) signupForm.addEventListener('submit', _signupSubmitHandler);
    if (signupSkip) signupSkip.addEventListener('click',  _signupSkipHandler);
  }

  /* ── Klaviyo subscription ───────────────────────────────────────────────────── */
  function submitToKlaviyo(email, callback) {
    var publicKey = signupSection ? signupSection.dataset.publicKey : '';
    var listId    = signupSection ? signupSection.dataset.listId    : '';
    if (!publicKey || !listId) { callback(false); return; }

    var profileAttributes = { email: email };

    /* Optional: first name */
    var nameInput = document.getElementById('svd-signup-name');
    if (nameInput && nameInput.value.trim()) {
      profileAttributes.first_name = nameInput.value.trim();
    }

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + publicKey, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2023-12-15' },
      body:    JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: profileAttributes } }
          },
          relationships: {
            list: { data: { type: 'list', id: listId } }
          }
        }
      })
    })
    .then(function(r) { callback(r.ok || r.status === 202); })
    .catch(function()  { callback(false); });

    /* Fire-and-forget: attach quiz data to Klaviyo profile */
    if (signupSection && signupSection.dataset.sendQuizData === 'true') {
      fetch('https://a.klaviyo.com/client/profiles/?company_id=' + publicKey, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2023-12-15' },
        body:    JSON.stringify({
          data: {
            type: 'profile',
            attributes: {
              email: email,
              properties: {
                quiz_score:       quizScore,
                quiz_result:      quizResultType,
                quiz_has_symptom: quizHasSymptom
              }
            }
          }
        })
      }).catch(function() { /* silent — quiz data is best-effort */ });
    }
  }

  /* ── Show results (routes via signup if after_results) ─────────────────────── */
  function showResults() {
    computeScore();
    if (signupSection && signupSection.dataset.position === 'after_results') {
      showSignup(renderResults);
    } else {
      renderResults();
    }
  }

  /* ── Render result screens ──────────────────────────────────────────────────── */
  function renderResults() {
    var recommend = quizResultType === 'positive';

    if (recommend) {
      customisePositiveResult();
      show(resultPositive);
    } else {
      show(resultNeutral);
    }

    var target = recommend ? resultPositive : resultNeutral;
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* Personalise positive result title based on first symptom answer */
  function customisePositiveResult() {
    var titleEl = document.getElementById('svd-result-positive-title');
    var bodyEl  = document.getElementById('svd-result-positive-body');
    if (!titleEl || !bodyEl) return;

    var symptomLabel = '';
    for (var s = 1; s <= totalSteps; s++) {
      if (answers[s] && answers[s].symptom) {
        symptomLabel = answers[s].label;
        break;
      }
    }

    if (symptomLabel) {
      titleEl.textContent = 'Din hund verkar behöva extra stöd för: ' + symptomLabel.toLowerCase();
    }
  }

  /* ── Restart ───────────────────────────────────────────────────────────── */
  function restart() {
    answers        = {};
    currentStep    = 1;
    quizScore      = 0;
    quizResultType  = '';
    quizHasSymptom  = false;
    hide(resultPositive);
    hide(resultNeutral);
    hide(loadingSection);
    hideStickyBar();
    /* Reset signup */
    if (signupSection) {
      hide(signupSection);
      if (signupForm)    show(signupForm);
      if (signupError)   hide(signupError);
      if (signupSuccess) hide(signupSuccess);
      var emailInput = document.getElementById('svd-signup-email');
      var nameInput  = document.getElementById('svd-signup-name');
      if (emailInput) emailInput.value = '';
      if (nameInput)  nameInput.value  = '';
    }
    if (_signupSubmitHandler && signupForm) {
      signupForm.removeEventListener('submit', _signupSubmitHandler);
      _signupSubmitHandler = null;
    }
    if (_signupSkipHandler && signupSkip) {
      signupSkip.removeEventListener('click', _signupSkipHandler);
      _signupSkipHandler = null;
    }
    document.querySelectorAll('.svd-quiz-option.is-selected').forEach(function (b) {
      b.classList.remove('is-selected');
    });
    show(startSection);
    startSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  var restartPos = document.getElementById('svd-restart-pos');
  var restartNeu = document.getElementById('svd-restart-neu');
  if (restartPos) restartPos.addEventListener('click', restart);
  if (restartNeu) restartNeu.addEventListener('click', restart);

  } /* end init */

  /* ── Boot ───────────────────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
